function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import IdentifyPage from 'researcher/application/components/IdentifyPage';
import Link from 'shared/components/Link';
import { T } from 'shared/helper/translate';
import featureEnabled from 'shared/helper/feature';
import ForgotPasswordForm from './ForgotPasswordForm';
import ForgotPasswordV2 from './ForgotPasswordV2';
var ForgotPassword = function ForgotPassword(_ref) {
  var _requestPasswordReset = _ref.requestPasswordReset,
    status = _ref.status;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    passwordResetEmail = _useState2[0],
    setPasswordResetEmail = _useState2[1];
  var showNewLogin = featureEnabled('rubriq_ui_revamp');
  useEffect(function () {
    window.scrollTo(0, 0);
  }, [passwordResetEmail]);
  return /*#__PURE__*/React.createElement("div", null, !showNewLogin ? /*#__PURE__*/React.createElement("div", {
    className: "container login new-button-styles"
  }, /*#__PURE__*/React.createElement(IdentifyPage, {
    title: "Forgot your password?"
  }), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-10 offset-md-1"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Forgot your password?"
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement(T.md, {
    source: "forgot-password-message"
  })))), !passwordResetEmail ? /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-6 offset-md-3"
  }, /*#__PURE__*/React.createElement(ForgotPasswordForm, {
    requestPasswordReset: function requestPasswordReset(formData) {
      return _requestPasswordReset(formData).then(function (_ref2) {
        var error = _ref2.error;
        if (!error) {
          setPasswordResetEmail(formData.email);
        }
      });
    },
    processing: status.processing
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-8 offset-md-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "alert alert-success"
  }, /*#__PURE__*/React.createElement(T.md, {
    source: "password-reset-request-success",
    params: {
      email: passwordResetEmail
    }
  })), /*#__PURE__*/React.createElement("ul", {
    className: "list-inline text-center"
  }, /*#__PURE__*/React.createElement("li", {
    className: "list-inline-item border-end me-1 pe-1"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/login"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Login"
  }))), /*#__PURE__*/React.createElement("li", {
    className: "list-inline-item ms-0 ps-0"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/register"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Sign Up"
  }))))))) : /*#__PURE__*/React.createElement(ForgotPasswordV2, {
    passwordResetEmail: passwordResetEmail,
    processing: status.processing,
    requestPasswordReset: function requestPasswordReset(formData) {
      return _requestPasswordReset(formData).then(function (_ref3) {
        var error = _ref3.error;
        if (!error) {
          setPasswordResetEmail(formData.email);
        }
      });
    }
  }));
};
export default ForgotPassword;